enum RequestedFeature {
  ApplyTradeIn = 'ApplyTradeIn',
  ApplyVerboseLogging = 'ApplyVerboseLogging',
  ConditionalTiles = 'ConditionalTiles',
  DealershipConditionalTiles = 'DealershipConditionalTiles',
  EarliestAcquisitionBoosting = 'EarliestAcquisitionBoosting',
  ExcludeFacetData = 'ExcludeFacetData',
  FetchTradeIn = 'FetchTradeIn',
  HideImpossibleCombos = 'HideImpossibleCombos',
  LocationBasedPrefiltering = 'LocationBasedPrefiltering',
  LoanTermPricing = 'LoanTermPricing',
  Personalization = 'Personalization',
  ShaqvanaConditionalTile = 'ShaqvanaConditionalTile',
  Sprinkles = 'Sprinkles'
}

export default RequestedFeature;
